import { Cloudinary, signatoryName } from "../../../../services/utilities";
import "./style.css";

const Signature = ({
  person,
  label,
  topLabel,
  topLabelStyle = {},
  style = {},
  withSignature,
}) => {
  return (
    <div style={style} className="text-center position-relative">
      {topLabel && (
        <h6
          className="fw-bold mb-0 text-uppercase text-left"
          style={{
            fontSize: "0.75rem",
            position: "relative",
            zIndex: 1,
            ...topLabelStyle,
          }}
        >
          {topLabel}
        </h6>
      )}
      {/* room to sign by hand when no signature image is printed */}
      {topLabel && !withSignature && (
        <div className="laboratory-signing-space" />
      )}
      {/* Signature behind the name */}
      {withSignature && (
        <img
          style={{
            height: 80,
            opacity: 0.6,
            marginBottom: "-1.5rem",
            zIndex: 0,
            position: "relative",
          }}
          src={`${Cloudinary.getEndpoint()}/${person?.sid || ""}/users/${
            person?.email
          }/signature.png`}
          onError={(e) => (e.target.style.display = "none")} // hide if not found
          alt={person?.email || "signature"}
        />
      )}

      <h5
        className="fw-bold mb-0"
        style={{
          fontSize: "1.1rem",
          position: "relative",
          zIndex: 1, // Bring text in front
        }}
      >
        <u>{signatoryName(person?.fullName)}</u>
      </h5>

      <div style={{ position: "relative", zIndex: 1 }}>
        {label}
        <h6 style={{ fontSize: "0.8rem" }}>
          {label !== "Encoder" && person?.prc && ` PRC#: ${person?.prc.id}`}{" "}
        </h6>
      </div>
    </div>
  );
};

// 3rd slot is the encoder, or the section validator when hasValidator is true
export default function Signatories({ signatories = [], hasValidator = false }) {
  const head = signatories[0],
    dr = signatories[1],
    frontdesk = signatories[2];

  return (
    <div className="pt-4 px-3 laboratory-signatories">
      <div className="d-flex justify-content-between">
        <Signature
          person={head}
          label="Medical Laboratory Scientist"
          topLabel={hasValidator && "Processed by:"}
          // style={{ marginTop: "-0.5rem" }}
          withSignature={head?.withSignature}
        />
        {hasValidator ? (
          <Signature
            person={frontdesk}
            label="Medical Laboratory Scientist"
            topLabel="Validated by:"
            topLabelStyle={{ marginLeft: "-4rem" }}
            withSignature={frontdesk?.withSignature}
          />
        ) : (
          <Signature person={frontdesk} label="Encoder" isHalf />
        )}
      </div>
      <Signature
        person={dr}
        label="Pathologist"
        style={{ marginTop: "-0.5rem" }}
        withSignature
      />
    </div>
  );
}
